// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"30b40518","884":"55b42fce"}[chunkId] + ".chunk.js";
};